import React, { Component } from 'react'
import connexion from '../../connexion'
import { ArrowRightIcon } from '@heroicons/react/solid'
import '../UI/Skeleton.css'
import { Link } from 'react-router-dom'

class ModulePage extends Component {
	constructor(props) {
		super(props)
		this.state = {
			page: null,
			category: null
		}
		this._mounted = false
	}

	componentDidMount() {
		this._mounted = true
		if (this.props.page)
		{
			this.props.fetchPageByID(this.props.page)
			.then(page => {
				if (this._mounted)
					this.setState({ page: page })
			})
			.catch(err => console.log(err))
		}
		else
		{
			this.props.fetchPageByCategory(this.props.category)
			.then(page => {
				this.props.fetchCategoryByID(this.props.category)
				.then(category => {
					if (this._mounted)
						this.setState({ page: page, category: category })
				})
				.catch(err => console.log(err))
			})
			.catch(err => console.log(err))
		}
	}

	componentWillUnmount() {
		this._mounted = false
	}

	render() {
		const page = this.state.page
		const groups = this.props.groups
		const category = this.state.category
		if (this.props.page && page)
		{
			let page_url = ""
			for (let i = 0; i < page.translations.length; i++)
			{
				if (page.translations[i].lang === this.props.user.lang)
				{
					page_url = page.translations[i].url
					break
				}
			}
			const url = this.props.lang_assets.paths.pages + "/" + page_url
			if (page.cover !== null || page.cover_ext)
			{
				const cover = "url(" + connexion.connect.url + 'webapp/pages/cover?id=' + page._id + ")"
				return (
					<div>
						<h2 className="text-xl font-bold ml-5 mt-7">{this.props.title}</h2>
						<Link to={url}>
							<div className="pressable w-11/12 mt-3 relative mx-auto mb-5 rounded-2xl h-56 bg-cover bg-center shadow-lg overflow-hidden" style={{ backgroundImage: cover }}>
							<div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-gray-900"></div>
							<div className="absolute left-4 bottom-4 right-14 text-white">
								<p className="text-lg font-bold leading-tight">{this.props.subtitle}</p>
								{this.props.meta &&
									<p className="mt-0.5 text-xs font-medium uppercase tracking-wide" style={{ opacity: 0.85 }}>{this.props.meta}</p>
								}
							</div>
							<span className="absolute right-3 bottom-3 h-8 w-8 rounded-full flex items-center justify-center" style={{ backgroundColor: 'rgba(255, 255, 255, 0.22)' }}>
								<ArrowRightIcon className="h-4 w-4 text-white" />
							</span>
							</div>
						</Link>
					</div>
				)
			}
			else
			{
				return (
					<div>
						<h2 className="text-xl font-bold ml-5 mt-7">{this.props.title}</h2>
						<Link to={url}>
							<div className="ModuleLayout">
								<p>{this.props.subtitle}</p>
							</div>
						</Link>
					</div>
				)
			}
		}
		else if (page && category)
		{
			let group = null
			for (let i = 0; i < groups.length; i++)
			{
				if (groups[i]._id === category.group)
				{
					group = groups[i]
					break
				}
			}
			let url = this.props.lang_assets.paths.rubrics + '/'
			let prefix = ""
			if (group === null)
				console.log("group null, page:", page._id, "category:", category._id)
			if (group && group.translations)
			{
				for (let i = 0; i < group.translations.length; i++)
				{
					if (group.translations[i].lang === this.props.user.lang)
					{
						prefix = group.translations[i].prefix
						break
					}
				}
			}
			let suffix = ""
			for (let i = 0; i < category.translations.length; i++)
			{
				if (category.translations[i].lang === this.props.user.lang)
				{
					suffix = category.translations[i].suffix
					break
				}
			}
			if (group !== null)
				url = this.props.lang_assets.paths.rubrics + '/' + prefix + '/' + suffix
			if (page && (page.cover !== null || page.cover_ext))
			{
				const cover = "url(" + connexion.connect.url + 'webapp/pages/cover?id=' + page._id + ")"
				return (
					<div>
						<h2 className="text-xl font-bold ml-5 mt-7">{this.props.title}</h2>
						<Link to={url}>
							<div className="pressable w-11/12 mt-3 relative mx-auto mb-5 rounded-2xl h-56 bg-cover bg-center shadow-lg overflow-hidden" style={{ backgroundImage: cover }}>
							<div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-gray-900"></div>
							<div className="absolute left-4 bottom-4 right-14 text-white">
								<p className="text-lg font-bold leading-tight">{this.props.subtitle}</p>
								{this.props.meta &&
									<p className="mt-0.5 text-xs font-medium uppercase tracking-wide" style={{ opacity: 0.85 }}>{this.props.meta}</p>
								}
							</div>
							<span className="absolute right-3 bottom-3 h-8 w-8 rounded-full flex items-center justify-center" style={{ backgroundColor: 'rgba(255, 255, 255, 0.22)' }}>
								<ArrowRightIcon className="h-4 w-4 text-white" />
							</span>
							</div>
						</Link>
					</div>
				)
			}
			else
			{
				return (
					<div>
						<h2 className="text-xl font-bold ml-5 mt-7">{this.props.title}</h2>
						<Link to={url}>
							<div className="pressable w-11/12 mt-3 relative mx-auto mb-5 rounded-2xl h-56 bg-cover bg-center shadow-lg overflow-hidden">
							<div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-gray-900"></div>
							<div className="absolute left-4 bottom-4 right-14 text-white">
								<p className="text-lg font-bold leading-tight">{this.props.subtitle}</p>
								{this.props.meta &&
									<p className="mt-0.5 text-xs font-medium uppercase tracking-wide" style={{ opacity: 0.85 }}>{this.props.meta}</p>
								}
							</div>
							<span className="absolute right-3 bottom-3 h-8 w-8 rounded-full flex items-center justify-center" style={{ backgroundColor: 'rgba(255, 255, 255, 0.22)' }}>
								<ArrowRightIcon className="h-4 w-4 text-white" />
							</span>
							</div>
						</Link>
					</div>
				)
			}
		}
		else
		{
			return (
				<div>
					<h2 className="text-xl font-bold ml-5 mt-7">{this.props.title}</h2>
					<div className="w-11/12 mt-3 mx-auto mb-5 rounded-xl h-56 sk-anim"></div>
				</div>
			)
		}
	}
}

export default ModulePage